import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { History } from "./screens/History/History";
import { Rankings } from "./screens/Rankings/Rankings";
import Dashboard from "./screens/Dashboard/Dashboard";
import { EscalationCompleted } from "./screens/EscalationCompleted/EscalationCompleted";
import UploadData from "./screens/uploadData/UploadData";
import Configuration from "./screens/configuration/Configuration";
import Login from "./screens/login/Login";
import PrivateRoutes from "./PrivateRoutes";
import PageNotFound from "./screens/pagenotfound/PageNotFound";
import Exculded from "./screens/excluded/Exculded";
import UserManagement from "./screens/admin/userManagement/UserManagement";
import Logs from "./screens/admin/logs/Logs";
import { ContextData } from "./ContextData";
import DataManagement from "./screens/admin/dataManagement/DataManagement";
import ResetPassword from "./screens/resetPassword/ResetPassword";
import ForgotPassword from "./screens/forgotPassword/ForgotPassword";
import VerifyOtpPage from "./screens/forgotPassword/VerifyOtpPage";
import ChangePasswordPage from "./screens/forgotPassword/ChangePasswordPage";
import StatusManagement from "./screens/admin/StatusManagement/StatusManagement";
import RankingAlgorithmSettins from "./screens/admin/RankingAlgorithmSetting/RankingAlgorithmSetting";
import FlightModelManagement from "./screens/admin/FlightModelManagement/FlightModelManagement";
import ExcludedTab from "./screens/excluded/ExcludedTab";

export const Routesmap = () => {
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("userRole")) {
      setUserRole(localStorage.getItem("userRole"));
    }
  }, []);

  return (
    <div
      style={{
        backgroundColor: "#F5F6FB",
        minHeight: "100vh",
      }}
    >
      <ContextData.Provider value={{ userRole, setUserRole }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/forgot-password/verify-otp"
            element={<VerifyOtpPage />}
          />
          <Route
            path="/forgot-password/change-password"
            element={<ChangePasswordPage />}
          />
          <Route element={<PrivateRoutes />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/ranking" element={<Rankings />} />
            <Route path="/history" element={<History />} />
            <Route
              path="/escalationCompleted"
              element={<EscalationCompleted />}
            />
            <Route path="/uploadData" element={<UploadData />} />
            {/* <Route path="/excluded" element={<Exculded />} />
             */}
             <Route path="/excludedTab" element={<ExcludedTab />} />
            <Route path="/settings" element={<Configuration />} />
            {userRole === "admin" && (
              <Route path="/admin">
                <Route path="user-management" element={<UserManagement />} />
                <Route path="data-management" element={<DataManagement />} />
                <Route path="logs" element={<Logs />} />
                <Route
                  path="status-management"
                  element={<StatusManagement />}
                />
                <Route
                  path="ranking-algorithm-settings"
                  element={<RankingAlgorithmSettins />}
                />
                <Route
                  path="flight-model-management"
                  element={<FlightModelManagement />}
                />
              </Route>
            )}
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ContextData.Provider>
    </div>
  );
};
